module.exports = __webpack_public_path__ + "static/Outlook_Money-e11a93f6d0b925f1518b5c4520446e77.png";